import { Link } from "react-router-dom";
import { ShieldCheck, Truck, CreditCard, Banknote } from "lucide-react";
import { Logo } from "@/components/store/Header";
import { useSettings } from "@/lib/hooks";

export default function Footer() {
  const s = useSettings();
  return (
    <footer className="mt-16 bg-[#0B1437] text-slate-300">
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo light />
          <p className="mt-3 text-sm text-slate-400">Kedi ve köpek maması, kampanyalı fiyatlarla kapınızda.</p>
        </div>
        <div className="space-y-2 text-sm">
          <div className="font-display text-white font-semibold mb-2">Güvenli Alışveriş</div>
          <div className="flex items-center gap-2"><Banknote className="h-4 w-4" />Havale / EFT</div>
          <div className="flex items-center gap-2"><CreditCard className="h-4 w-4" />Kredi kartı & kapıda ödeme</div>
          <div className="flex items-center gap-2"><ShieldCheck className="h-4 w-4" />256-bit güvenli bağlantı</div>
        </div>
        <div className="text-sm">
          <div className="font-display text-white font-semibold mb-2">Kargo Firmaları</div>
          <div className="flex flex-wrap gap-1.5">
            {(s?.cargo_companies || []).map((c) => <span key={c.name} className="px-2 py-0.5 rounded bg-white/10 text-xs flex items-center gap-1"><Truck className="h-3 w-3" />{c.name}</span>)}
          </div>
        </div>
        <div className="text-sm space-y-2">
          <div className="font-display text-white font-semibold mb-2">Hesap</div>
          <Link to="/giris" className="block hover:text-white">Üye Ol / Giriş</Link>
          <Link to="/hesabim" className="block hover:text-white">Siparişlerim</Link>
          <Link to="/yonetim" data-testid="footer-admin-link" className="block hover:text-white">Yönetim Paneli</Link>
        </div>
      </div>
      <div className="border-t border-white/10 text-center text-xs text-slate-500 py-4">© {new Date().getFullYear()} onlinesatiyorum.com</div>
    </footer>
  );
}
